module.exports = __webpack_public_path__ + "media/images/login_google-454460135a3f1b37b50750962a944638.svg";